import request from '@/utils/request'

// 查询特种设备预约管理列表
export function listTzsbOld(query) {
  return request({
    url: '/web/msy/tzsbOld/list',
    method: 'get',
    params: query
  })
}
